import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ExamAttachDelete.css';
const cx = classNames.bind(styles);

class ExamAttachDelete extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { deleting, templateInfo, removeTemplate, handleOnToggleDeleteModal } = this.props;
    const { attachInfoNo, attachSubject, regEpoch } = templateInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleDeleteModal}
        visible
        header={
          <div>{defineMessages(formatMessage({ id: 'ExamAttachDelete_1', defaultMessage: '첨부파일 삭제' }))}</div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleDeleteModal}>
              {defineMessages(formatMessage({ id: 'ExamTemplateDelete_2', defaultMessage: '취소' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={deleting} disabled={deleting} onClick={removeTemplate}>
              {defineMessages(formatMessage({ id: 'ExamTemplateDelete_3', defaultMessage: '삭제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={deleting}
          size="small"
          content={defineMessages(formatMessage({ id: 'ExamTemplateDelete_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ExamAttachDelete_2',
              defaultMessage: '삭제한 첨부파일은 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ExamAttachDelete_5',
              defaultMessage: '다음 첨부파일을 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          {/* <Message.Header>
            {defineMessages(
              formatMessage({
                id: 'ExamAttachDelete_2',
                defaultMessage: '삭제한 첨부파일은 복구할 수 없습니다. 다음 첨부파일을 삭제합니까?'
              })
            )}
          </Message.Header> */}
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {attachInfoNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamAttachDelete_3', defaultMessage: '제목' }))}
                </div>
                {attachSubject}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamAttachDelete_4', defaultMessage: '등록일' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

ExamAttachDelete.propTypes = {
  //
};
ExamAttachDelete.defaultProps = {
  //
};

export default injectIntl(ExamAttachDelete);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachDelete.js